import { createContext } from 'react'

export type WebRouteContextValue = {
  isFocused: boolean
  route: {
    key: string
    name: string
    params: Record<string, unknown>
  }
}

export const WebRouteContext = createContext<WebRouteContextValue | null>(null)
